<template>
    <div class="content-wrapper  " style="background-color:#eee ; height: 100%">
    <div class="container">



        <CCard>
            <CCardHeader>
                <router-link :to="{path: '/sprint/create'}" class="btn btn-success">افزودن پروژه جدید</router-link>


                <button type="button" class="btn btn-default" style="float: left"
                        v-on:click="tableToExcel('testTable', 'W3C Example Table')" >Export Excel</button>

                <button  type="button" class="btn btn-info" data-toggle="modal" style="float: left;margin-left: 10px"
                         data-target="#importExcel">
                    Import Excel</button>
                <!--<button type="button" class="btn btn-default" style="float: left" v-print="'#printMe'" >پرینت لیست {{$customerLable}} ها</button>-->

            </CCardHeader>
            <CCardBody>


                <div class="panel panel-default ">
                    <div class="panel-heading" >


                        <div class="row mb-4">
                            <div class="col-md-10">
                                <input type="text" v-model="search" @keyup="changeUpDown()" class="form-control input-search "
                                       placeholder="جستجو">
                            </div>
                            <div class="col-md-2">
                                <select class="select-search form-control" v-model="length" @change="changeUpDown()">
                                    <option value="25" >25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </div>






                    </div>
                    <div class="panel-body  ">
                        <div class="table-responsive">


                            <table  id="testTable" class="table table-bordered table-striped table-hover">
                                <thead>
                                <tr>
                                    <th> آیدی </th>
<!--                                    <th>   کد (غیرخودکار)</th>-->
<!--                                    <th > سردسته</th>-->
                                    <th  @click="changeUpDown(`title`,`desc`)"> عنوان</th>
                                    <!--                        <th>تصویر</th>-->

                                    <th>توضیحات</th>
                                    <!--<th>وضعیت </th>-->
                                    <th>وضعیت</th>
                                    <th width="100">&nbsp;</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr id="items" v-for="(item, index) in items" :key="index">

                                    <td> {{ item.id }}
                                    </td>

<!--                                    <td> {{ item.code }}-->
<!--                                    </td>-->
<!--                                    <td>-->
<!--                                        <b v-if="item.parent_id">-->
<!--                                            {{ item.parent.title }}-->
<!--                                        </b>-->
<!--                                        <b v-else>-->
<!--                                            - -->
<!--                                        </b>-->
<!--                                    </td>-->
                                    <td>{{ item.title }}
                                        <!--                            <span  v-if="!item.parent_id" style="color: #aa0c5f"> (سردسته) </span>-->
                                    </td>
                                    <!--                        <td>{{ item.image }}</td>-->
                                    <!-- <td>{{ item.parent_id }}</td> -->

                                    <td>{{ item.description }}</td>
                                    <td>{{ item.state }}</td>


                                    <td>

                                        <router-link :to="{path: '/sprint/edit/'+item.id, params: {id: item.id}}">
                                            ویرایش
                                        </router-link>
                                        <a href="javascript: void(0)"
                                           class="btn btn-xs btn-danger"
                                           v-on:click="deleteEntry(item.id, index)">
                                            حذف
                                        </a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>



                            <!-- Modal -->
                            <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div class="modal-body">
                                            ...
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                            <button type="button" class="btn btn-primary">Save changes</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                </div>


            </CCardBody>
        </CCard>


        
    </div>
    <div class="col-xs-12 text-center">
        <pagination :api="'/api/sprints?search='+search+'&column='+col+'&length='+length+'&order='+orderMod" @pagnationChangeDate='pagnation'></pagination>


    </div>








        <!-- Modal -->
        <div id="importExcel" class="modal fade " role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">


                    <form v-on:submit.prevent="getAttaches()">

                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                            <h4 class="modal-title"> Import Excel</h4>
                        </div>
                        <div class="modal-body">

                            <div class="row">
                                <div class="col-xs-12 form-group">
                                    <label class="control-label">Excel </label>
                                    <div class="form-group">
                                        <div class="input-group input-file" name="Fichier1">
                                            <input type="text" class="form-control" :placeholder="placeholder" />
                                            <input type="file" class="filestyle" ref="file" @change="onFileChangeNote($event)" />
                                            <span class="input-group-btn">
                                            <!--<button class="btn btn-default btn-choose" type="button">فایل</button>-->
                                        </span>
                                        </div>
                                    </div>
                                </div>
                            </div>




                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default"
                                    data-dismiss="modal"> {{ $t('Close') }}</button>
                            <button class="btn btn-primary" data-dismiss="modal" @click="importExcel"> {{ $t('done') }} </button>
                        </div>


                    </form>

                </div>

            </div>
        </div>












    </div>
</template>


<script>



    const auth = {
        headers: {Authorization:'bearer ' + localStorage.getItem('token')}
    };

    export default {

        data: function () {

            
            return {
                auth: {headers: {Authorization: 'bearer ' + localStorage.getItem('token')}},
                items: [],
                errors:[],


                search: "",
                length: "",
                orderIcon: "",
                orderMod:'desc',

                col: "",


                excel:{
                    file: '',

                },
                placeholder: '  انتخاب کنید',



            }
        },


        mounted () {
            axios
                .get('/api/sprints?search='+this.search+'&column='+this.col+'&length='+this.length+'&order='+this.orderMod, this.auth)
                .then(response => {
                    this.items = response.data.data;
                    console.log(this.items);

                })
                .catch(error => {
                    this.loader = false
                    if (error.response.data.message == 'User does not have any of the necessary access rights.') {
                        this.$snotify.warning('دسترسی شما برای این بخش محدود شده است');
                    } else {
                        this.$snotify.warning(error.response.data.message);
                    }
                    console.log(error);
                    this.errored = true
                })
                .finally(() => this.loading = false)
        }


        ,
        methods: {





            changeUpDown(column, orderBY) {
                let app = this
                let col = column
                let orderMod = orderBY
                if (column == undefined || column == null) {
                    col = ""
                }
                if (orderBY == undefined || orderBY == null) {
                    orderMod = "asc"

                }
                if (orderBY == "asc") {
                    app.orderIcon = "desc"

                } else {
                    app.orderIcon = "asc"
                }
                console.log(app.orderIcon)
                setTimeout(function () {
                    // app.loader = true

                    axios
                        .get(
                            `/api/sprints?search=${app.search}&column=${col}&length=${app.length}&order=${orderMod}`,
                            app.auth)
                        .then(response => {
                            app.items = response.data.data;
                            app.loader = false
                            console.log(app.items);

                        })
                        .catch(error => {
                            console.log(error);
                            app.loader = false
                            app.errored = true
                        })
                        .finally(() => app.loading = false)
                }, 2000)
            },
            keysearch(search) {

                let app = this
                app.loader = true
                setTimeout(function () {
                    axios
                        .get(`/api/sprints?search=${search}`, app.auth)
                        .then(response => {
                            app.items = response.data.data;
                            app.loader = false
                            console.log(app.items);

                        })
                        .catch(error => {
                            console.log(error);
                            app.errored = true
                        })
                        .finally(() => app.loading = false)
                }, 1000)

            },
            pagnation(api) {
                // console.log(api,"m")
                axios.get(api, this.auth)
                    .then(response => {
                        // this.current_page = response.data.current_page
                        this.items = response.data.data;
                        //  console.log(response.data.data)
                        // this.pagnationDate = response.data
                        //  console.log(this.pagnationDate)
                    })
                    .catch(error => {
                        console.log(error);
                        this.errored = true
                    })
                    .finally(() => this.loading = false)
            },

            deleteEntry(id, index) {
                if (confirm("از حذف آیتم مطمئن هستید؟")) {
                    var app = this;
                    axios.delete('/api/sprints/' + id , app.auth)
                        .then(function (resp) {
                            app.items.splice(index, 1);
                        })
                        .catch(function (resp) {
                            alert("امکان حذف آیتم وجود ندارد");
                        });
                }
            },


            getRelation(id) {
                    axios.get('api/sprints' + id , this.auth)
                        .then(function (resp) {
                            console.log(resp.data.data.id);
                            return resp.data.data.id;
                        })
                        .catch(function (resp) {
                            return 'نا مشخص';
                        });
            },




            tableToExcel (table, name) {

                var uri = 'data:application/vnd.ms-excel;base64,'
                    , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
                    , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
                    , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }


                if (!table.nodeType) table = document.getElementById(table)
                var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
                window.location.href = uri + base64(format(template, ctx))

            },


            onFileChangeNote(e) {
                this.excel.file = this.$refs.file.files[0];
                this.placeholder = this.$refs.file.files[0].name
                console.log(this.excel ,"note ch 144")
            },




            importExcel() {
                var app = this;
                var newItem = app.excel;

                let formData = new FormData();
                for (const key in newItem) {
                    if (newItem.hasOwnProperty(key)) {
                        const element = newItem[key];
                        formData.append(key, element)
                        console.log(key, element);
                    }
                }

                axios
                    .post(`/api/sprintAdd/importExcel`,formData, app.auth)
                    //                axios.post('/api/services', formData, app.auth)
                    .then(function (resp) {
                        app.$snotify.success(app.$t('Item saved successfully'));

                    })
                    .catch(function (e) {
                        console.log(e.response.data);

                        for (let value of e.response.data.messages_fa) {
                            app.$snotify.warning(value, {
                                timeout: 7000,
                                closeOnClick: true,
                                pauseOnHover: true
                            });
                        }
                    });





            },








        }
    }
</script>
<!--<script>-->
    <!--export default {-->
        <!--computed: {-->
            <!--username() {-->
                <!--// We will see what `params` is shortly-->
                <!--return this.$route.params.username-->
            <!--}-->
        <!--},-->
        <!--methods: {-->
            <!--goBack() {-->
                <!--window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')-->
            <!--}-->
        <!--}-->
    <!--}-->
<!--</script>-->